import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-fidelity-module-tabs',
  standalone: true,
  imports: [
    MatTabsModule,
    TranslateModule
  ],
  templateUrl: './fidelity-module-tabs.component.html',
  styleUrl: './fidelity-module-tabs.component.scss'
})
export class FidelityModuleTabsComponent {
  
  @Output() tabPanelChange = new EventEmitter<string>();
  @Input() getTabChange: number = -1;
  
  @ViewChild(MatTabGroup) tabGroup!: MatTabGroup;

}
